export default __webpack_public_path__ + "static/media/brx_logo_horizontal.b064855b.webp";